// EstadoOptimizacionFoto — P3-9b (pantalla). Avance de ESCRITURA de una foto en la
// vista previa: en cola → optimizando (spinner) → lista (peso final) o error (motivo
// + «Reintentar»). Presentacional y testeable aparte de la ficha.
import React from 'react';
import { RefreshCw, CheckCircle2 } from 'lucide-react';
import { pesoLegible } from '../utils/fotosOptimizar';

// est: { estado:'cola'|'optimizando'|'lista'|'error', pesoNuevo, error } o undefined.
export default function EstadoOptimizacionFoto({ est, onReintentar, disabled = false }) {
  if (!est) return null;
  if (est.estado === 'cola') return <span className="pp-opt-estado">en cola</span>;
  if (est.estado === 'optimizando') {
    return <span className="pp-opt-estado pp-opt-estado--run"><RefreshCw size={12} aria-hidden="true" className="pp-spin" /> optimizando…</span>;
  }
  if (est.estado === 'lista') {
    return <span className="pp-opt-estado pp-opt-estado--ok"><CheckCircle2 size={12} aria-hidden="true" /> lista · {pesoLegible(est.pesoNuevo)}</span>;
  }
  if (est.estado === 'error') {
    return (
      <span className="pp-opt-estado pp-opt-estado--err">
        error: {est.error}{' '}
        <button type="button" className="pp-opt-reintentar" onClick={onReintentar} disabled={disabled}>Reintentar</button>
      </span>
    );
  }
  return null;
}
